import * as React from 'react';

export const SelectIcon = (
  props: React.SVGProps<SVGSVGElement>,
): JSX.Element => {
  return (
    <svg
      viewBox="0 0 16.12 16.12"
      {...props}
    >
      <path
        fill="#006e52"
        d="M8.06 16.12a8.06 8.06 0 118.06-8.06 8.06 8.06 0 01-8.06 8.06zm0-15.19a7.13 7.13 0 107.13 7.13A7.15 7.15 0 008.06.93z"
        data-name="Path 3019"
      />
      <path
        fill="#006e52"
        d="M7 12.33a1.22 1.22 0 01-.87-.33L3.38 9.24a1.26 1.26 0 111.77-1.79L7 9.29l4.4-4.39a1.26 1.26 0 011.78 1.78L7.9 12a1.26 1.26 0 01-.9.33z"
        data-name="Path 3020"
      />
    </svg>
    // <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 20 20" fill="none">
    //   <path fill-rule="evenodd" clip-rule="evenodd" d="M9.99967 0.833313C4.93717 0.833313 0.833008 4.93748 0.833008 9.99998C0.833008 15.0625 4.93717 19.1666 9.99967 19.1666C15.0622 19.1666 19.1663 15.0625 19.1663 9.99998C19.1663 4.93748 15.0622 0.833313 9.99967 0.833313ZM13.973 8.44998C14.0462 8.36635 14.1019 8.26893 14.1368 8.16345C14.1718 8.05798 14.1853 7.94658 14.1766 7.8358C14.1678 7.72503 14.137 7.61712 14.086 7.51842C14.0349 7.41972 13.9647 7.33223 13.8793 7.2611C13.7939 7.18996 13.6952 7.13662 13.5889 7.1042C13.4826 7.07178 13.3709 7.06095 13.2604 7.07234C13.1499 7.08372 13.0427 7.1171 12.9453 7.17051C12.8479 7.22391 12.7621 7.29627 12.693 7.38331L9.10968 11.6825L7.25551 9.82748C7.09834 9.67568 6.88784 9.59169 6.66934 9.59359C6.45084 9.59548 6.24183 9.68312 6.08733 9.83763C5.93282 9.99214 5.84518 10.2011 5.84328 10.4196C5.84138 10.6381 5.92538 10.8486 6.07718 11.0058L8.57718 13.5058C8.65906 13.5876 8.75709 13.6515 8.86502 13.6934C8.97295 13.7352 9.08842 13.7541 9.20407 13.7489C9.31971 13.7436 9.43299 13.7143 9.53668 13.6629C9.64038 13.6114 9.73222 13.5389 9.80634 13.45L13.973 8.44998Z" fill="#26375F" />
    // </svg>
  );
};
